export const SOCIAL_PLATFORMS = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "twitter", label: "Twitter" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "gmb", label: "GMB" },
  { value: "youtube", label: "YouTube" },
];

export const SOCIAL_PLATFORM_VALUES = SOCIAL_PLATFORMS.map((p) => p.value);

export function socialPlatformLabel(value) {
  const match = SOCIAL_PLATFORMS.find((p) => p.value === value);
  return match ? match.label : value;
}
